import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QbusTranslateService {
  constructor(private translate: TranslateService) {}

  async translateAll<T extends Record<string, string>>(
    items: T,
    params?: { [Property in keyof T]?: any },
  ): Promise<T> {
    const promises = Object.entries(items).map(async ([key, value]) => {
      const translation = await firstValueFrom<string>(
        this.translate.get(value, params?.[key]),
      );
      return [key, translation];
    });

    const result = await Promise.all(promises);
    return Object.fromEntries(result);
  }

  translateAllInstant<T extends Record<string, string>>(
    items: T,
    params?: { [Property in keyof T]?: any },
  ): T {
    const keyValues = Object.entries(items).map(([key, value]) => {
      const translation: string = this.translate.instant(value, params?.[key]);
      return [key, translation];
    });

    return Object.fromEntries(keyValues);
  }
}
